export const FORM_DATA_LOCAL_STORAGE_KEY = 'MBM_FORM_DATA'
export const SETTINGS_LOCAL_STORAGE_KEY = 'MBM_SETTINGS'
export const PRESIGNED_URL_EXPIRY = 3600 * 24 // 1 day
export const BUCKET_FILE_EXPIRY = 7 * 24 * 60 * 60 * 1000 // 7 days
export const BIODATA_DOWNLOADS_LOCAL_STORAGE_KEY = 'MBM_BIODATA_DOWNLOADS'
export const ADSENSE_PUB_ID = 'ca-pub-7793357145882383'
export const DISCOUNT_PERCENT = 0.5 // 50%
export const FREE_TEMPLATE_ID = 'MBM_039'
export const PAID_TEMPLATE_BUCKET_KEY_LENGTH = 7
export const FREE_TEMPLATE_BUCKET_KEY_LENGTH = 6
export const MAX_EMAIL_SENDS = 3
export const EMAIL_SEND_COOKIE_PREFIX = 'email_sends_'
export const DOWNLOAD_CONFETTI_SESSION_KEY = 'mbm-download-confetti'
